export const GET_ALL_EVENTS = "GET_ALL_EVENTS"
export const GET_ALL_EVENTS_RESPONSE_SUCCESS = "GET_ALL_EVENTS_RESPONSE_SUCCESS"
